import React, { Component } from 'react';
import{
    Container,
    Col,
    Row,
    Button,
    Table,
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Input,
    Modal,
    ModalBody,
    ModalFooter
} from 'reactstrap';
/**
 * Used for the Listino Prezzi section. 
 */
export class AddArticoli extends Component {

    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.toggleErrorModal = this.toggleErrorModal.bind(this);

        this.state = {
            articolo: {},
            um: [],
            umHeight: 'auto',
            quantita: 1,
            prezzo: '0',
            note: '',
            dataConsegna: new Date().toISOString().split('T')[0],
            dropdownOpen: false,
            dropdownText: 'Seleziona UM',
            errorModal: false,
            sconto1: 0,
            sconto2: 0,
            KG: 'KG',
            PZ:'PZ'
        };
    
    }

    
    /**
     * Runs upon initial mount of the /listinoPrezzi path
     */
    componentDidMount(){

        fetch(`/api/articoli/${this.props.match.params.id}`, {   
            method: 'GET',
            headers: new Headers({
                //Authorization token
                'Authorization': 'Bearer ' + sessionStorage.getItem("auth"),
                //Sets the content type. Necessary for the server to recognize the information
                'Content-Type': 'application/json' 
            }),
            //Changes the response to an object
        }).then(response => response.json())
        .then(myjson => {
            this.setState({
                articolo: myjson
            })

        }).catch(e => {

        });

        fetch(`/api/articoli/um`, {   
            method: 'GET',
            headers: new Headers({
                //Authorization token
                'Authorization': 'Bearer ' + sessionStorage.getItem("auth"),
                //Sets the content type. Necessary for the server to recognize the information
                'Content-Type': 'application/json' 
            }),
            //Changes the response to an object
        }).then(response => response.json())
        .then(myjson => {
            this.setState({
                um: myjson
            })

        }).catch(e => {

        });

        fetch(`/api/cliente/${sessionStorage.getItem("codiceCliente")}/articoli/${this.props.match.params.id}/prezzo`, {   
            method: 'GET',
            headers: new Headers({
                //Authorization token
                'Authorization': 'Bearer ' + sessionStorage.getItem("auth"),
                //Sets the content type. Necessary for the server to recognize the information
                'Content-Type': 'application/json' 
            }),
            //Changes the response to an object
        }).then(response => response.json())
        .then(myjson => {
            this.setState({
                prezzo: myjson

            }, () => console.log(this.state.prezzo))

        }).catch(e => {

        });
     
    }    

    toggle() {
        if(this.state.dropdownOpen){
            this.setState({
                dropdownOpen: !this.state.dropdownOpen,
                umHeight: 'auto',
            });
        }
        else{
            this.setState({
                dropdownOpen: !this.state.dropdownOpen,
                umHeight: '30vh',
            });
        }
    }

    toggleErrorModal = () => {
        this.setState({
            errorModal: !this.state.errorModal
        })
    }
    dropdownOnSelect(text) {
        this.setState({
            dropdownText: text
        })
    }

    handleDateChange = (e) => {
        this.setState({
            dataConsegna: e.target.value
        })
    }

    handleQuantitaChange = (value) => {
        const newQuantita = this.state.quantita + value;
       

        if (newQuantita > 0) {
            this.setState({
                quantita: newQuantita,
                
            })
        }
    }

    //handleSconto1Change = (value) => {
    //    const newSconto = this.state.prezzo.maxSconto1;

    //    if(newSconto > 0 && newSconto <= this.state.prezzo.maxSconto1){
    //        this.setState({
    //            sconto1: newSconto
    //        })
    //    }
    //}

    //handleSconto2Change = (value) => {
    //    const newSconto = this.state.quantita + value;

    //    if(newSconto > 0 && newSconto <= this.state.prezzo.maxSconto2){
    //        this.setState({
    //            sconto2: newSconto
    //        })
    //    }
    //}

    handleNoteChange = (e) => {
        this.setState({
            note: e.target.value
        })
    }

    handleInserisciClick = () => {
        if(this.state.dropdownText === 'Seleziona UM'){
            this.toggleErrorModal();
        }
        else{
            let totalStima = 0;
            let stimaSenzaSconto = 0;

            if(this.state.dropdownText === 'KG'){
                if(this.state.prezzo.um === 'KG'){
                    stimaSenzaSconto = this.state.prezzo.prezzo * this.state.quantita; 
                }
                else if(this.state.prezzo.um === 'PZ'){
                    stimaSenzaSconto = (this.state.prezzo.peso * this.state.quantita) * this.state.prezzo.prezzo;
                }
            }
            else if(this.state.dropdownText === 'PZ'){
                if(this.state.prezzo.um === 'KG'){
                    stimaSenzaSconto = (this.state.prezzo.prezzo * this.state.prezzo.peso) * this.state.quantita;
                }
                else if(this.state.prezzo.um === 'PZ'){
                    stimaSenzaSconto = this.state.prezzo.prezzo * this.state.quantita;
                }
            }
            else if(this.state.dropdownText === 'MT'){
                if(this.state.prezzo.um === 'KG'){
                    stimaSenzaSconto = (this.state.prezzo.prezzo / this.state.prezzo.peso) * this.state.quantita;
                }
                else if(this.state.prezzo.um === 'PZ'){
                    stimaSenzaSconto = this.state.prezzo.prezzo * this.state.quantita * this.state.prezzo.cartonaggio;
                }
                else if(this.state.prezzo.um === 'MT'){
                    stimaSenzaSconto = this.state.prezzo.prezzo * this.state.quantita;
                }
            }
            else{
                if(this.state.prezzo.um === 'KG'){
                    stimaSenzaSconto = (this.state.prezzo.prezzo / this.state.prezzo.peso) * this.state.quantita;
                }
                else if(this.state.prezzo.um === 'PZ'){
                    stimaSenzaSconto = this.state.prezzo.prezzo;
                }
            }
            totalStima = stimaSenzaSconto;

            let minSconto1 = 0;

            if(this.state.sconto1 !== 0){
                minSconto1 = (totalStima * ((this.state.sconto1*1.0)/100))

                totalStima -= minSconto1;
            }

            let minSconto2 = 0;

            if(this.state.sconto2 !== 0){
                minSconto2 = (totalStima * ((this.state.sconto2*1.0)/100))

                totalStima -= minSconto2;
            }
            
            const tempArticolo = {
                articoloId: this.props.match.params.id,
                articoloUm: this.state.prezzo.um,
                quantita: this.state.quantita,
                um: this.state.dropdownText,
                prezzo: this.state.prezzo,
                sconto1: this.state.sconto1,
                sconto2: this.state.sconto2,
                dataConsegna: this.state.dataConsegna,
                note: this.state.note,
                stimaSenzaSconto: stimaSenzaSconto,
                stimaConSconto1: minSconto1,
                stimaConSconto2: minSconto2,
                totalStima: totalStima,
            }
            console.log(tempArticolo);

            const tempArray = JSON.parse(sessionStorage.getItem("articoli"));
            tempArray.push(tempArticolo);

            sessionStorage.setItem("articoli", JSON.stringify(tempArray));

            this.props.history.push('/order/add');
        }
    }

    /**
     * Renders the page
     */
    render() {

        const titolo = (
            <h5 style={{color: "#011e41", fontWeight: "bold", margin: "0px"}}>Aggiungi un Articolo</h5>
        );

        return (
            <Container fluid style={{minHeight: '75vh'}}> 
                <Container className="d-flex align-items-center" fluid> 
                    <Row className="d-flex justify-content-center align-items-center" style={{width: "100vw", margin: "0px", padding: "0px"}}>
                        <Col className="d-flex align-items-center justify-content-center" style={{width: "100%", margin: "0px", padding: "0px"}}>
                            {titolo}
                        </Col>
                    </Row>
                </Container>
                <Container className="d-flex align-items-center" fluid>
                        <Row className="d-flex justify-content-center align-items-center" style={{width: "100vw", margin: "0px", padding: "0px"}}>
                            <Col className="d-flex align-items-center justify-content-center" style={{width: "100%", margin: "0px", padding: "0px", paddingTop: "5px", paddingBottom: "5px", marginTop: "10px"}}>
                                <Table responsive borderless style={{width: "50%", margin: "0", marginTop: "5px"}}>
                                    <tbody style={{fontSize: "20px"}}>                                     
                                        <tr>
                                            <th style={{width: "25%", padding: "0", paddingRight: "20px", textAlign: "right"}}>Articolo:  </th>
                                            <td align="left" style={{padding: "0"}}>
                                                {this.props.match.params.id}
                                            </td>
                                        </tr>
                                    </tbody>
                                </Table>                                    
                            </Col>
                        </Row> 
                </Container>
                <Container className="d-flex align-items-center" fluid>
                        <Row className="d-flex justify-content-center align-items-center" style={{width: "100vw", margin: "0px", padding: "0px"}}>
                            <Col className="d-flex align-items-center justify-content-center" style={{width: "100%", margin: "0px", padding: "0px", paddingTop: "5px", paddingBottom: "5px", marginTop: "10px"}}>
                                <Table responsive borderless style={{width: "50%", margin: "0", marginTop: "5px"}}>
                                    <tbody style={{fontSize: "20px"}}>
                                        <tr>
                                        <th style={{width: "25%", padding: "0", paddingRight: "20px", textAlign: "right"}}>Articolo:  </th>
                                            <td align="left" style={{padding: "0", height: `${this.state.umHeight}`}}>
                                                <div>    
                                                    <Dropdown style={{width: '40%', textAlign: 'center'}} isOpen={this.state.dropdownOpen} toggle={this.toggle}>
                                                        <DropdownToggle style={{width: '100%', padding: '0px', backgroundColor: "#011e41", fontSize: "20px"}} caret>
                                                            {this.state.dropdownText}
                                                        </DropdownToggle>
                                                        <DropdownMenu
                                                            modifiers={{
                                                                setMaxHeight: {
                                                                enabled: true,
                                                                order: 890,
                                                                fn: (data) => {
                                                                    return {
                                                                    ...data,
                                                                    styles: {
                                                                        ...data.styles,
                                                                        overflow: 'auto',
                                                                        maxHeight: "50vh",
                                                                    },
                                                                    };
                                                                },
                                                                },
                                                                computeStyle: {
                                                                    gpuAcceleration: false
                                                                }
                                                        }}>
                                                        {this.state.prezzo.um == 'KG'}?
                                                                <DropdownItem id={'KG'} onClick={() => this.dropdownOnSelect(this.state.KG)} style={{ color: "#011e41" }}>
                                                                    KG
                                                                </DropdownItem>
                                                                <DropdownItem id={'PZ'} onClick={() => this.dropdownOnSelect(this.state.PZ)} style={{ color: "#011e41" }}>
                                                                    PZ
                                                                </DropdownItem> :
                                                                <DropdownItem id={'PZ'} onClick={() => this.dropdownOnSelect(this.state.PZ)} style={{ color: "#011e41" }}>
                                                                    PZ
                                                                </DropdownItem>                                                            
                                                        </DropdownMenu>
                                                    </Dropdown>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </Table>                                    
                            </Col>
                        </Row> 
                </Container>
                <Container className="d-flex align-items-center" fluid>
                        <Row className="d-flex justify-content-center align-items-center" style={{width: "100vw", margin: "0px", padding: "0px"}}>
                            <Col className="d-flex align-items-center justify-content-center" style={{width: "100%", margin: "0px", padding: "0px", paddingTop: "5px", paddingBottom: "5px", marginTop: "10px"}}>
                                <Table responsive borderless style={{width: "50%", margin: "0", marginTop: "5px"}}>
                                    <tbody style={{fontSize: "20px"}}>
                                        <tr>
                                            <th style={{width: "25%", padding: "0", paddingRight: "20px", textAlign: "right"}}>Quantita:  </th>
                                            <td align="left" style={{padding: "0"}}>
                                                <div>    
                                                <Button onClick={() => this.handleQuantitaChange(-1)} style={{padding: "0px", width: "3vw", marginRight: "10px", borderWidth: "medium", color: "#011e41", borderColor: "#011e41", backgroundColor: "transparent", fontSize: "20px", verticalAlign:"middle", textAlign: "center", fontWeight: "bold"}}>-</Button>
                                                        {this.state.quantita}
                                                    <Button onClick={() => this.handleQuantitaChange(1)} style={{padding: "0px", width: "3vw", marginLeft: "10px", borderWidth: "medium", color: "#011e41", borderColor: "#011e41", backgroundColor: "transparent", fontSize: "20px", verticalAlign:"middle", textAlign: "center", fontWeight: "bold"}}>+</Button>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </Table>    
                            </Col>
                        </Row> 
                </Container>
                <Container className="d-flex align-items-center" fluid>
                        <Row className="d-flex justify-content-center align-items-center" style={{width: "100vw", margin: "0px", padding: "0px"}}>
                            <Col className="d-flex align-items-center justify-content-center" style={{width: "100%", margin: "0px", padding: "0px", paddingTop: "5px", paddingBottom: "5px", marginTop: "10px"}}>
                                <Table responsive borderless style={{width: "50%", margin: "0", marginTop: "5px"}}>
                                    <tbody style={{fontSize: "20px"}}>
                                        <tr>
                                            <th style={{width: "25%", padding: "0", paddingRight: "20px", textAlign: "right"}}>Prezzo:  </th>
                                            <td align="left" style={{padding: "0"}}>
                                                <div>    
                                                    {this.state.prezzo.um !== 'NR' ?
                                                        <div>€{this.state.prezzo.prezzo} / {this.state.prezzo.um}</div> :
                                                        <div>€{this.state.prezzo.prezzo}</div>
                                                    }
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </Col>
                        </Row> 
                </Container>
                <div>
                    {this.state.prezzo.maxSconto1 > 0 ?
                        <Container className="d-flex align-items-center" fluid>
                            <Row className="d-flex justify-content-center align-items-center" style={{width: "100vw", margin: "0px", padding: "0px"}}>
                                <Col className="d-flex align-items-center justify-content-center" style={{width: "100%", margin: "0px", padding: "0px", paddingTop: "5px", paddingBottom: "5px", marginTop: "10px"}}>
                                    <Table responsive borderless style={{width: "50%", margin: "0", marginTop: "5px"}}>
                                        <tbody style={{fontSize: "20px"}}>
                                            <tr>
                                                <th style={{width: "25%", padding: "0", paddingRight: "20px", textAlign: "right"}}>Sconto 1:  </th>
                                                <td align="left" style={{padding: "0"}}>
                                                    <div>   
                                                            {this.state.prezzo.maxSconto1}
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </Table>    
                                </Col>
                            </Row> 
                    </Container> : null
                    }
                </div>
                <div>
                    {this.state.prezzo.maxSconto2 > 0 ? 
                        <Container className="d-flex align-items-center" fluid>
                                <Row className="d-flex justify-content-center align-items-center" style={{width: "100vw", margin: "0px", padding: "0px"}}>
                                    <Col className="d-flex align-items-center justify-content-center" style={{width: "100%", margin: "0px", padding: "0px", paddingTop: "5px", paddingBottom: "5px", marginTop: "10px"}}>
                                        <Table responsive borderless style={{width: "50%", margin: "0", marginTop: "5px"}}>
                                            <tbody style={{fontSize: "20px"}}>
                                                <tr>
                                                    <th style={{width: "25%", padding: "0", paddingRight: "20px", textAlign: "right"}}>Sconto 2:  </th>
                                                    <td align="left" style={{padding: "0"}}>
                                                        <div>    
                                                                {this.state.sconto2}
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </Table>    
                                    </Col>
                                </Row> 
                        </Container> : null
                    }
                </div>
                
                <Container className="d-flex align-items-center" fluid>
                        <Row className="d-flex justify-content-center align-items-center" style={{width: "100vw", margin: "0px", padding: "0px"}}>
                            <Col className="d-flex align-items-center justify-content-center" style={{width: "100%", margin: "0px", padding: "0px", paddingTop: "5px", paddingBottom: "5px", marginTop: "10px"}}>
                                <Table responsive borderless style={{width: "50%", margin: "0", marginTop: "5px"}}>
                                    <tbody style={{fontSize: "20px"}}>
                                        <tr>
                                            <th style={{width: "25%", padding: "0", paddingRight: "20px", textAlign: "right"}}>Data di Consegna:  </th>
                                            <td align="left" style={{padding: "0"}}>
                                            <Input type="date" name="dataDiConsegna" id="dataDiConsegna" style={{height: "100%", width: "100%", fontSize: "20px", padding: "0", paddingLeft: "5px"}} onChange={this.handleDateChange} value={this.state.dataConsegna}/>
                                            </td>
                                        </tr>
                                    </tbody>
                                </Table>  
                            </Col>
                        </Row> 
                </Container> 
                <Container className="d-flex align-items-center" fluid>
                        <Row className="d-flex justify-content-center align-items-center" style={{width: "100vw", margin: "0px", padding: "0px"}}>
                            <Col className="d-flex align-items-center justify-content-center" style={{width: "100%", margin: "0px", padding: "0px", paddingTop: "5px", paddingBottom: "5px", marginTop: "10px"}}>
                                <Table responsive borderless style={{width: "100%", margin: "0", marginTop: "5px"}}>
                                    <tbody style={{fontSize: "20px"}}>
                                        <tr>
                                            <th style={{width: "12.5%", padding: "0", paddingRight: "20px", textAlign: "right"}}>Note:  </th>
                                            <td align="left" style={{padding: "5px", height: `15vh`}}>
                                                <Input type="textarea" name="note" id="note" style={{height: "100%", width: "100%", fontSize: "20px", padding: "0", paddingLeft: "5px"}} onChange={this.handleNoteChange} value={this.state.note}/>
                                            </td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </Col>
                        </Row> 
                </Container>
                <Container className="d-flex align-items-center" fluid>
                        <Row className="d-flex justify-content-center align-items-center" style={{width: "100vw", margin: "0px", padding: "0px"}}>
                            <Col className="d-flex align-items-center justify-content-center" style={{width: "100%", margin: "0px", padding: "0px", paddingTop: "5px", paddingBottom: "5px", marginTop: "10px"}}>
                                <Button type="button" className="text-center" onClick={this.handleInserisciClick} style={{width: '50%', padding: '0px', backgroundColor: "#011e41", fontSize: "20px"}}>
                                    Inserisci riga
                                </Button>   
                            </Col>
                        </Row> 
                </Container> 
                <Modal isOpen={this.state.errorModal} toggle={this.toggleErrorModal} style={{color: "#011e41"}}>
                    <ModalBody>
                        <Container className="d-flex justify-content-center align-items-center" fluid>
                            Controlli l'unità di misura
                        </Container>
                    </ModalBody>
                    <ModalFooter>
                        <Container className="d-flex justify-content-center align-items-center" fluid>
                            <Button className="text-center" style={{width: '50%', padding: '0px', backgroundColor: "#011e41", fontSize: "20px"}} onClick={() => this.setState({errorModal: false})}>
                                Ok
                            </Button>
                        </Container>
                    </ModalFooter>
                </Modal>
            </Container> 
        )
    }
}

/*{this.state.um.map((unit, index) => {
      return (
          <div key={index}>
              {this.state.prezzo.um === 'MT' && unit !== 'NR' ?
                  <DropdownItem id={index} onClick={() => this.dropdownOnSelect(unit)} style={{color: "#011e41"}}>
                      {unit}
                  </DropdownItem> :
                  <div>
                      {unit !== 'NR' && unit !== 'MT' ?
                          <DropdownItem key={index} id={index} onClick={() => this.dropdownOnSelect(unit)} style={{color: "#011e41"}}>
                              {unit}
                          </DropdownItem> : null
                      }
                  </div>
              }
          </div>
  
  
      )
  })}*/


// WEBPACK FOOTER //
// ./src/components/AddArticoli.js